import { ILectureRate } from '#types/rates';

export const REVIEW_LIST: { id: keyof ILectureRate; title: string }[] = [
  { id: 'coachNice', title: '친절도' },
  { id: 'lectureQuality', title: '전문성' },
  { id: 'timeNice', title: '시간 약속' }
];
